import { render, staticRenderFns } from "./share_document_v2.vue?vue&type=template&id=5cb14c07&scoped=true"
import script from "./share_document_v2.vue?vue&type=script&lang=js"
export * from "./share_document_v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb14c07",
  null
  
)

export default component.exports